// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"56bf13a6978d9d08e33d","5338":"7d3fb2190065f2152827"}[chunkId] + ".js";
};